import _ from 'lodash';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'actions' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').FormTemplate} FormTemplate
 * @typedef {import('vuex').ActionContext<State>} ActionContext
 */

/**
 * @typedef {Object} GetTemplatesActionOpts
 * @property {string} organization
 * @property {string} creator account uid
 *
 * @callback GetTemplatesAction
 * @param {ActionContext} ctx
 * @param {GetTemplatesActionOpts} opts
 * @returns {Promise<FormTemplate>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {GetTemplatesAction}
 */
export const getTemplates = (store, sdk) => async (ctx, opts) => {
  opts = Object.assign({}, opts);
  const query = { $limit: 20 };

  if (!opts.allowHidden) query.hiddenAt = null;

  if (opts.organization) query.facility = opts.organization;

  if (opts.creator) query.createdBy = opts.creator;

  if (!_.isEmpty(opts.ids)) query.id = { $in: opts.ids };

  if (opts.type) query.type = opts.type;
  if (opts.sort) query.$sort = opts.sort;

  // pagination
  if (typeof opts.limit === 'number') query.$limit = opts.limit;
  if (typeof opts.skip === 'number') query.$skip = opts.skip;

  if (opts.searchString) {
    query.name = { $regex: `^${opts.searchString}`, $options: 'i' };
  }
  const { items } = await sdk.form.templates().find(query);

  if (!items.length) {
    ctx.commit('setTemplates', items);
  } else {
    ctx.commit('updateInTemplates', { items, upsert: true });
  }

  return items;
};

/**
 * @typedef {Object} LoadTemplatesActionOpts
 * @property {string} organization
 * @property {string} creator account uid
 *
 * @callback LoadTemplatesAction
 * @param {ActionContext} ctx
 * @param {LoadTemplatesActionOpts} opts
 * @returns {Promise<FormTemplate>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {LoadTemplatesAction}
 */
export const loadTemplates = (store, sdk) => async (ctx, opts) => {
  opts = Object.assign({}, opts);
  const query = { $limit: 20 };

  if (!opts.allowHidden) query.hiddenAt = null;

  if (opts.organization) {
    query.$or = query.$or || [];
    query.$or.push({ facility: opts.organization });
  }

  if (opts.creator) {
    query.$or = query.$or || [];
    query.$or.push({ createdBy: opts.creator });
  }

  if (!_.isEmpty(opts.ids)) query.id = { $in: opts.ids };

  if (opts.type) query.type = opts.type;
  if (opts.sort) query.$sort = opts.sort;

  // pagination
  if (typeof opts.limit === 'number') query.$limit = opts.limit;
  if (typeof opts.skip === 'number') query.$skip = opts.skip;

  if (opts.searchString) {
    query.name = { $regex: `^${opts.searchString}`, $options: 'i' };
  }
  const res = await sdk.form.templates().find(query);
  return res;
};
